module.exports = __webpack_public_path__ + "static/media/landpage-about.80edf0a0.png";